import {styled} from "@mui/material/styles";
import {Switch, Tooltip, tooltipClasses} from "@mui/material";
import * as React from "react";

export const green = '#1D8B45';
export const light_green = '#F0FDF3';
export const yellow = '#F2BE22';
export const orange = '#FF8911';
export const light_orange = '#FBD288';
export const grey = '#424242';
export const lightgrey = '#B7B7B7';
export const red = '#FF0303';
export const red2 = '#DC3545';
export const blue = '#384559';
export const white = '#FFFFFF';
export const mainHeading = '24px';
export const sectionHeading = '20px';
export const subHeading = '18px';
export const defaultText = '16px';
export const textContent = '14px';
export const noteContent = '12px';
export const backgroundColor = '#FFFFFF';

export const greenButtonContained = {
    backgroundColor: green,
    "&:hover": {
        backgroundColor: green,
        filter: 'brightness(0.9)'
    }
}

export const yellowButtonContained = {
    backgroundColor: yellow,
    "&:hover": {
        backgroundColor: yellow,
        filter: 'brightness(0.9)'
    }
}

export const greyButtonContained = {
    backgroundColor: grey,
    "&:hover": {
        backgroundColor: grey,
        filter: 'brightness(0.9)'
    }
}

export const greenButtonOutlined = {
    border: '2px solid #1D8B45',
    "&:hover": {
        border: '2px solid #1D8B45',
        filter: 'brightness(0.9)'
    }
}

export const greyButtonOutlined = {
    border: '2px solid #384559',
    "&:hover": {
        border: '2px solid #384559',
        filter: 'brightness(0.9)'
    }
}

export const AntSwitch = styled(Switch)(({theme}) => ({
    width: 30,
    height: 18,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 17,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#609966' : '#609966',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 14,
        height: 14,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));

export const textFieldColor = {
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused:not(.Mui-error) fieldset': {
            borderColor: green, // Focused border color when not in error
        },
    },
}

export const LightTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));

export const styles = {
    root: {
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
        gap: '20px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '30px'
    },
    root2: {
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
        gap: '20px',
        display: 'flex',
        flexDirection: 'column',
    },
    section: {
        padding: '20px 40px 0'
    },
    content: {
        padding: '0 40px 20px'
    },
    headingWithIcon: {
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    warning: {
        padding: '15px',
        border: '2px solid #FF8911',
        borderRadius: '5px',
        backgroundColor: light_orange,
        display: 'flex',
        gap: '10px'
    }
}

